export interface Country {
  country_code: string;
  flag_code: string;
  phone_code: number;
  region: string;
  region_aggregated: string;
  value: string;
  label: string;
}

export const COUNTRY_DATA = [
  {
    country_code: "AF",
    flag_code: "AF",
    phone_code: 93,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Afghanistan",
    label: "Afghanistan",
  },
  {
    country_code: "AL",
    flag_code: "AL",
    phone_code: 355,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Albania",
    label: "Albania",
  },
  {
    country_code: "DZ",
    flag_code: "DZ",
    phone_code: 213,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Algeria",
    label: "Algeria",
  },
  {
    country_code: "AS",
    flag_code: "AS",
    phone_code: 1684,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "American Samoa",
    label: "American Samoa",
  },
  {
    country_code: "AD",
    flag_code: "AD",
    phone_code: 376,
    region: "Southern Europe",
    region_aggregated: "Europe",
    value: "Andorra",
    label: "Andorra",
  },
  {
    country_code: "AO",
    flag_code: "AO",
    phone_code: 244,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Angola",
    label: "Angola",
  },
  {
    country_code: "AI",
    flag_code: "AI",
    phone_code: 1264,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Anguilla",
    label: "Anguilla",
  },
  {
    country_code: "AQ",
    flag_code: "AQ",
    phone_code: 672,
    region: "Other (Europe)",
    region_aggregated: "Europe",
    value: "Antarctica",
    label: "Antarctica",
  },
  {
    country_code: "AG",
    flag_code: "AG",
    phone_code: 1268,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Antigua and Barbuda",
    label: "Antigua and Barbuda",
  },
  {
    country_code: "AR",
    flag_code: "AR",
    phone_code: 54,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Argentina",
    label: "Argentina",
  },
  {
    country_code: "AM",
    flag_code: "AM",
    phone_code: 374,
    region: "Central & Eastern Europe",
    region_aggregated: "Middle East",
    value: "Armenia",
    label: "Armenia",
  },
  {
    country_code: "AW",
    flag_code: "AW",
    phone_code: 297,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Aruba",
    label: "Aruba",
  },
  {
    country_code: "AU",
    flag_code: "AU",
    phone_code: 61,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Australia",
    label: "Australia",
  },
  {
    country_code: "AT",
    flag_code: "AT",
    phone_code: 43,
    region: "Western Europe",
    region_aggregated: "Europe",
    value: "Austria",
    label: "Austria",
  },
  {
    country_code: "AZ",
    flag_code: "AZ",
    phone_code: 994,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Azerbaijan",
    label: "Azerbaijan",
  },
  {
    country_code: "BH",
    flag_code: "BH",
    phone_code: 973,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Bahrain",
    label: "Bahrain",
  },
  {
    country_code: "BD",
    flag_code: "BD",
    phone_code: 880,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Bangladesh",
    label: "Bangladesh",
  },
  {
    country_code: "BB",
    flag_code: "BB",
    phone_code: 1246,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Barbados",
    label: "Barbados",
  },
  {
    country_code: "BY",
    flag_code: "BY",
    phone_code: 375,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Belarus",
    label: "Belarus",
  },
  {
    country_code: "BE",
    flag_code: "BE",
    phone_code: 32,
    region: "Western Europe",
    region_aggregated: "Europe",
    value: "Belgium",
    label: "Belgium",
  },
  {
    country_code: "BZ",
    flag_code: "BZ",
    phone_code: 501,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Belize",
    label: "Belize",
  },
  {
    country_code: "BJ",
    flag_code: "BJ",
    phone_code: 229,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Benin",
    label: "Benin",
  },
  {
    country_code: "BM",
    flag_code: "BM",
    phone_code: 1441,
    region: "North America",
    region_aggregated: "North America",
    value: "Bermuda",
    label: "Bermuda",
  },
  {
    country_code: "BT",
    flag_code: "BT",
    phone_code: 975,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Bhutan",
    label: "Bhutan",
  },
  {
    country_code: "BO",
    flag_code: "BO",
    phone_code: 591,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Bolivia",
    label: "Bolivia",
  },
  {
    country_code: "BQ",
    flag_code: "NL",
    phone_code: 599,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Bonaire, Sint Eustatius and Saba",
    label: "Bonaire, Sint Eustatius and Saba",
  },
  {
    country_code: "BA",
    flag_code: "BA",
    phone_code: 387,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Bosnia and Herzegovina",
    label: "Bosnia and Herzegovina",
  },
  {
    country_code: "BW",
    flag_code: "BW",
    phone_code: 267,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Botswana",
    label: "Botswana",
  },
  {
    country_code: "BV",
    flag_code: "NO",
    phone_code: 47,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Bouvet Island",
    label: "Bouvet Island",
  },
  {
    country_code: "BR",
    flag_code: "BR",
    phone_code: 55,
    region: "Brazil",
    region_aggregated: "Brazil",
    value: "Brazil",
    label: "Brazil",
  },
  {
    country_code: "IO",
    flag_code: "IO",
    phone_code: 246,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "British Indian Ocean Territory",
    label: "British Indian Ocean Territory",
  },
  {
    country_code: "BN",
    flag_code: "BN",
    phone_code: 673,
    region: "East Asia & Pacific",
    region_aggregated: "East Asia & Pacific",
    value: "Brunei",
    label: "Brunei",
  },
  {
    country_code: "BG",
    flag_code: "BG",
    phone_code: 359,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Bulgaria",
    label: "Bulgaria",
  },
  {
    country_code: "BF",
    flag_code: "BF",
    phone_code: 226,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Burkina Faso",
    label: "Burkina Faso",
  },
  {
    country_code: "BI",
    flag_code: "BI",
    phone_code: 257,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Burundi",
    label: "Burundi",
  },
  {
    country_code: "CV",
    flag_code: "CV",
    phone_code: 238,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Cabo Verde",
    label: "Cabo Verde",
  },
  {
    country_code: "KH",
    flag_code: "KH",
    phone_code: 855,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Cambodia",
    label: "Cambodia",
  },
  {
    country_code: "CM",
    flag_code: "CM",
    phone_code: 237,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Cameroon",
    label: "Cameroon",
  },
  {
    country_code: "CA",
    flag_code: "CA",
    phone_code: 1,
    region: "North America",
    region_aggregated: "North America",
    value: "Canada",
    label: "Canada",
  },
  {
    country_code: "KY",
    flag_code: "KY",
    phone_code: 1345,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Cayman Islands",
    label: "Cayman Islands",
  },
  {
    country_code: "CF",
    flag_code: "CF",
    phone_code: 236,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Central African Republic",
    label: "Central African Republic",
  },
  {
    country_code: "TD",
    flag_code: "TD",
    phone_code: 235,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Chad",
    label: "Chad",
  },
  {
    country_code: "JE",
    flag_code: "JE",
    phone_code: 44,
    region: "UK&I",
    region_aggregated: "Europe",
    value: "Channel Islands",
    label: "Channel Islands",
  },
  {
    country_code: "CL",
    flag_code: "CL",
    phone_code: 56,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Chile",
    label: "Chile",
  },
  {
    country_code: "CN",
    flag_code: "CN",
    phone_code: 86,
    region: "East Asia & Pacific",
    region_aggregated: "East Asia & Pacific",
    value: "China",
    label: "China",
  },
  {
    country_code: "CX",
    flag_code: "CX",
    phone_code: 61,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Christmas Island",
    label: "Christmas Island",
  },
  {
    country_code: "CC",
    flag_code: "CC",
    phone_code: 61,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Cocos (Keeling) Islands",
    label: "Cocos (Keeling) Islands",
  },
  {
    country_code: "CO",
    flag_code: "CO",
    phone_code: 57,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Colombia",
    label: "Colombia",
  },
  {
    country_code: "KM",
    flag_code: "KM",
    phone_code: 269,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Comoros",
    label: "Comoros",
  },
  {
    country_code: "CG",
    flag_code: "CG",
    phone_code: 242,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Congo",
    label: "Congo",
  },
  {
    country_code: "CK",
    flag_code: "CK",
    phone_code: 682,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Cook Islands",
    label: "Cook Islands",
  },
  {
    country_code: "CR",
    flag_code: "CR",
    phone_code: 506,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Costa Rica",
    label: "Costa Rica",
  },
  {
    country_code: "HR",
    flag_code: "HR",
    phone_code: 385,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Croatia",
    label: "Croatia",
  },
  {
    country_code: "CU",
    flag_code: "CU",
    phone_code: 53,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Cuba",
    label: "Cuba",
  },
  {
    country_code: "CW",
    flag_code: "CW",
    phone_code: 599,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Curaçao",
    label: "Curaçao",
  },
  {
    country_code: "CY",
    flag_code: "CY",
    phone_code: 357,
    region: "Southern Europe",
    region_aggregated: "Europe",
    value: "Cyprus",
    label: "Cyprus",
  },
  {
    country_code: "CZ",
    flag_code: "CZ",
    phone_code: 420,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Czech Republic",
    label: "Czech Republic",
  },
  {
    country_code: "CI",
    flag_code: "CI",
    phone_code: 225,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Côte d'Ivoire",
    label: "Côte d'Ivoire",
  },
  {
    country_code: "DK",
    flag_code: "DK",
    phone_code: 45,
    region: "Nordics",
    region_aggregated: "Europe",
    value: "Denmark",
    label: "Denmark",
  },
  {
    country_code: "DJ",
    flag_code: "DJ",
    phone_code: 253,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Djibouti",
    label: "Djibouti",
  },
  {
    country_code: "DM",
    flag_code: "DM",
    phone_code: 1767,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Dominica",
    label: "Dominica",
  },
  {
    country_code: "DO",
    flag_code: "DO",
    phone_code: 1,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Dominican Republic",
    label: "Dominican Republic",
  },
  {
    country_code: "CD",
    flag_code: "CD",
    phone_code: 243,
    region: "Africa",
    region_aggregated: "Africa",
    value: "DR Congo",
    label: "DR Congo",
  },
  {
    country_code: "EC",
    flag_code: "EC",
    phone_code: 593,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Ecuador",
    label: "Ecuador",
  },
  {
    country_code: "EG",
    flag_code: "EG",
    phone_code: 20,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Egypt",
    label: "Egypt",
  },
  {
    country_code: "SV",
    flag_code: "SV",
    phone_code: 503,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "El Salvador",
    label: "El Salvador",
  },
  {
    country_code: "GQ",
    flag_code: "GQ",
    phone_code: 240,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Equatorial Guinea",
    label: "Equatorial Guinea",
  },
  {
    country_code: "ER",
    flag_code: "ER",
    phone_code: 291,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Eritrea",
    label: "Eritrea",
  },
  {
    country_code: "EE",
    flag_code: "EE",
    phone_code: 372,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Estonia",
    label: "Estonia",
  },
  {
    country_code: "SZ",
    flag_code: "SZ",
    phone_code: 268,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Eswatini",
    label: "Eswatini",
  },
  {
    country_code: "ET",
    flag_code: "ET",
    phone_code: 251,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Ethiopia",
    label: "Ethiopia",
  },
  {
    country_code: "FO",
    flag_code: "FO",
    phone_code: 298,
    region: "Nordics",
    region_aggregated: "Europe",
    value: "Faeroe Islands",
    label: "Faeroe Islands",
  },
  {
    country_code: "FK",
    flag_code: "FK",
    phone_code: 500,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Falkland Islands (Malvinas)",
    label: "Falkland Islands (Malvinas)",
  },
  {
    country_code: "FJ",
    flag_code: "FJ",
    phone_code: 679,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Fiji",
    label: "Fiji",
  },
  {
    country_code: "FI",
    flag_code: "FI",
    phone_code: 358,
    region: "Nordics",
    region_aggregated: "Europe",
    value: "Finland",
    label: "Finland",
  },
  {
    country_code: "FR",
    flag_code: "FR",
    phone_code: 33,
    region: "Western Europe",
    region_aggregated: "Europe",
    value: "France",
    label: "France",
  },
  {
    country_code: "GF",
    flag_code: "GF",
    phone_code: 594,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "French Guiana",
    label: "French Guiana",
  },
  {
    country_code: "PF",
    flag_code: "PF",
    phone_code: 689,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "French Polynesia",
    label: "French Polynesia",
  },
  {
    country_code: "TF",
    flag_code: "TF",
    phone_code: 262,
    region: "Southern Europe",
    region_aggregated: "Europe",
    value: "French Southern Territories",
    label: "French Southern Territories",
  },
  {
    country_code: "GA",
    flag_code: "GA",
    phone_code: 241,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Gabon",
    label: "Gabon",
  },
  {
    country_code: "GM",
    flag_code: "GM",
    phone_code: 220,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Gambia",
    label: "Gambia",
  },
  {
    country_code: "GE",
    flag_code: "GE",
    phone_code: 995,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Georgia",
    label: "Georgia",
  },
  {
    country_code: "DE",
    flag_code: "DE",
    phone_code: 49,
    region: "Western Europe",
    region_aggregated: "Europe",
    value: "Germany",
    label: "Germany",
  },
  {
    country_code: "GH",
    flag_code: "GH",
    phone_code: 233,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Ghana",
    label: "Ghana",
  },
  {
    country_code: "GI",
    flag_code: "GI",
    phone_code: 350,
    region: "UK&I",
    region_aggregated: "Europe",
    value: "Gibraltar",
    label: "Gibraltar",
  },
  {
    country_code: "GR",
    flag_code: "GR",
    phone_code: 30,
    region: "Southern Europe",
    region_aggregated: "Europe",
    value: "Greece",
    label: "Greece",
  },
  {
    country_code: "GL",
    flag_code: "GL",
    phone_code: 299,
    region: "North America",
    region_aggregated: "North America",
    value: "Greenland",
    label: "Greenland",
  },
  {
    country_code: "GD",
    flag_code: "GD",
    phone_code: 1473,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Grenada",
    label: "Grenada",
  },
  {
    country_code: "GP",
    flag_code: "GP",
    phone_code: 590,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Guadeloupe",
    label: "Guadeloupe",
  },
  {
    country_code: "GU",
    flag_code: "GU",
    phone_code: 1671,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Guam",
    label: "Guam",
  },
  {
    country_code: "GT",
    flag_code: "GT",
    phone_code: 502,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Guatemala",
    label: "Guatemala",
  },
  {
    country_code: "GG",
    flag_code: "GG",
    phone_code: 44,
    region: "UK&I",
    region_aggregated: "Europe",
    value: "Guernsey",
    label: "Guernsey",
  },
  {
    country_code: "GN",
    flag_code: "GN",
    phone_code: 224,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Guinea",
    label: "Guinea",
  },
  {
    country_code: "GW",
    flag_code: "GW",
    phone_code: 245,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Guinea-Bissau",
    label: "Guinea-Bissau",
  },
  {
    country_code: "GY",
    flag_code: "GY",
    phone_code: 592,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Guyana",
    label: "Guyana",
  },
  {
    country_code: "HT",
    flag_code: "HT",
    phone_code: 509,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Haiti",
    label: "Haiti",
  },
  {
    country_code: "HM",
    flag_code: "AU",
    phone_code: 672,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Heard Island and McDonald Islands",
    label: "Heard Island and McDonald Islands",
  },
  {
    country_code: "VA",
    flag_code: "VA",
    phone_code: 39,
    region: "Southern Europe",
    region_aggregated: "Europe",
    value: "Holy See",
    label: "Holy See",
  },
  {
    country_code: "HN",
    flag_code: "HN",
    phone_code: 504,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Honduras",
    label: "Honduras",
  },
  {
    country_code: "HK",
    flag_code: "HK",
    phone_code: 852,
    region: "East Asia & Pacific",
    region_aggregated: "East Asia & Pacific",
    value: "Hong Kong",
    label: "Hong Kong",
  },
  {
    country_code: "HU",
    flag_code: "HU",
    phone_code: 36,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Hungary",
    label: "Hungary",
  },
  {
    country_code: "IS",
    flag_code: "IS",
    phone_code: 354,
    region: "Nordics",
    region_aggregated: "Europe",
    value: "Iceland",
    label: "Iceland",
  },
  {
    country_code: "IN",
    flag_code: "IN",
    phone_code: 91,
    region: "India",
    region_aggregated: "India",
    value: "India",
    label: "India",
  },
  {
    country_code: "ID",
    flag_code: "ID",
    phone_code: 62,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Indonesia",
    label: "Indonesia",
  },
  {
    country_code: "IR",
    flag_code: "IR",
    phone_code: 98,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Iran",
    label: "Iran",
  },
  {
    country_code: "IQ",
    flag_code: "IQ",
    phone_code: 964,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Iraq",
    label: "Iraq",
  },
  {
    country_code: "IE",
    flag_code: "IE",
    phone_code: 353,
    region: "UK&I",
    region_aggregated: "Europe",
    value: "Ireland",
    label: "Ireland",
  },
  {
    country_code: "IM",
    flag_code: "IM",
    phone_code: 44,
    region: "UK&I",
    region_aggregated: "Europe",
    value: "Isle of Man",
    label: "Isle of Man",
  },
  {
    country_code: "IL",
    flag_code: "IL",
    phone_code: 972,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Israel",
    label: "Israel",
  },
  {
    country_code: "IT",
    flag_code: "IT",
    phone_code: 39,
    region: "Southern Europe",
    region_aggregated: "Europe",
    value: "Italy",
    label: "Italy",
  },
  {
    country_code: "JM",
    flag_code: "JM",
    phone_code: 1876,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Jamaica",
    label: "Jamaica",
  },
  {
    country_code: "JP",
    flag_code: "JP",
    phone_code: 81,
    region: "Japan & Korea",
    region_aggregated: "Japan & Korea",
    value: "Japan",
    label: "Japan",
  },
  {
    country_code: "JO",
    flag_code: "JO",
    phone_code: 962,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Jordan",
    label: "Jordan",
  },
  {
    country_code: "KZ",
    flag_code: "KZ",
    phone_code: 7,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Kazakhstan",
    label: "Kazakhstan",
  },
  {
    country_code: "KE",
    flag_code: "KE",
    phone_code: 254,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Kenya",
    label: "Kenya",
  },
  {
    country_code: "KI",
    flag_code: "KI",
    phone_code: 686,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Kiribati",
    label: "Kiribati",
  },
  {
    country_code: "XK",
    flag_code: "XK",
    phone_code: 383,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Kosovo",
    label: "Kosovo",
  },
  {
    country_code: "KW",
    flag_code: "KW",
    phone_code: 965,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Kuwait",
    label: "Kuwait",
  },
  {
    country_code: "KG",
    flag_code: "KG",
    phone_code: 996,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Kyrgyzstan",
    label: "Kyrgyzstan",
  },
  {
    country_code: "LA",
    flag_code: "LA",
    phone_code: 856,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Laos",
    label: "Laos",
  },
  {
    country_code: "LV",
    flag_code: "LV",
    phone_code: 371,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Latvia",
    label: "Latvia",
  },
  {
    country_code: "LB",
    flag_code: "LB",
    phone_code: 961,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Lebanon",
    label: "Lebanon",
  },
  {
    country_code: "LS",
    flag_code: "LS",
    phone_code: 266,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Lesotho",
    label: "Lesotho",
  },
  {
    country_code: "LR",
    flag_code: "LR",
    phone_code: 231,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Liberia",
    label: "Liberia",
  },
  {
    country_code: "LY",
    flag_code: "LY",
    phone_code: 218,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Libya",
    label: "Libya",
  },
  {
    country_code: "LI",
    flag_code: "LI",
    phone_code: 423,
    region: "Western Europe",
    region_aggregated: "Europe",
    value: "Liechtenstein",
    label: "Liechtenstein",
  },
  {
    country_code: "LT",
    flag_code: "LT",
    phone_code: 370,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Lithuania",
    label: "Lithuania",
  },
  {
    country_code: "LU",
    flag_code: "LU",
    phone_code: 352,
    region: "Western Europe",
    region_aggregated: "Europe",
    value: "Luxembourg",
    label: "Luxembourg",
  },
  {
    country_code: "MO",
    flag_code: "MO",
    phone_code: 853,
    region: "East Asia & Pacific",
    region_aggregated: "East Asia & Pacific",
    value: "Macao",
    label: "Macao",
  },
  {
    country_code: "MG",
    flag_code: "MG",
    phone_code: 261,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Madagascar",
    label: "Madagascar",
  },
  {
    country_code: "MW",
    flag_code: "MW",
    phone_code: 265,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Malawi",
    label: "Malawi",
  },
  {
    country_code: "MY",
    flag_code: "MY",
    phone_code: 60,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Malaysia",
    label: "Malaysia",
  },
  {
    country_code: "MV",
    flag_code: "MV",
    phone_code: 960,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Maldives",
    label: "Maldives",
  },
  {
    country_code: "ML",
    flag_code: "ML",
    phone_code: 223,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Mali",
    label: "Mali",
  },
  {
    country_code: "MT",
    flag_code: "MT",
    phone_code: 356,
    region: "Southern Europe",
    region_aggregated: "Europe",
    value: "Malta",
    label: "Malta",
  },
  {
    country_code: "MH",
    flag_code: "MH",
    phone_code: 692,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Marshall Islands",
    label: "Marshall Islands",
  },
  {
    country_code: "MQ",
    flag_code: "MQ",
    phone_code: 596,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Martinique",
    label: "Martinique",
  },
  {
    country_code: "MR",
    flag_code: "MR",
    phone_code: 222,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Mauritania",
    label: "Mauritania",
  },
  {
    country_code: "MU",
    flag_code: "MU",
    phone_code: 230,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Mauritius",
    label: "Mauritius",
  },
  {
    country_code: "YT",
    flag_code: "YT",
    phone_code: 262,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Mayotte",
    label: "Mayotte",
  },
  {
    country_code: "MX",
    flag_code: "MX",
    phone_code: 52,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Mexico",
    label: "Mexico",
  },
  {
    country_code: "FM",
    flag_code: "FM",
    phone_code: 691,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Micronesia (Federated States of)",
    label: "Micronesia (Federated States of)",
  },
  {
    country_code: "MD",
    flag_code: "MD",
    phone_code: 373,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Moldova",
    label: "Moldova",
  },
  {
    country_code: "MC",
    flag_code: "MC",
    phone_code: 377,
    region: "Western Europe",
    region_aggregated: "Europe",
    value: "Monaco",
    label: "Monaco",
  },
  {
    country_code: "MN",
    flag_code: "MN",
    phone_code: 976,
    region: "East Asia & Pacific",
    region_aggregated: "East Asia & Pacific",
    value: "Mongolia",
    label: "Mongolia",
  },
  {
    country_code: "ME",
    flag_code: "ME",
    phone_code: 382,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Montenegro",
    label: "Montenegro",
  },
  {
    country_code: "MS",
    flag_code: "MS",
    phone_code: 1664,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Montserrat",
    label: "Montserrat",
  },
  {
    country_code: "MA",
    flag_code: "MA",
    phone_code: 212,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Morocco",
    label: "Morocco",
  },
  {
    country_code: "MZ",
    flag_code: "MZ",
    phone_code: 258,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Mozambique",
    label: "Mozambique",
  },
  {
    country_code: "MM",
    flag_code: "MM",
    phone_code: 95,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Myanmar",
    label: "Myanmar",
  },
  {
    country_code: "NA",
    flag_code: "NA",
    phone_code: 264,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Namibia",
    label: "Namibia",
  },
  {
    country_code: "NR",
    flag_code: "NR",
    phone_code: 674,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Nauru",
    label: "Nauru",
  },
  {
    country_code: "NP",
    flag_code: "NP",
    phone_code: 977,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Nepal",
    label: "Nepal",
  },
  {
    country_code: "NL",
    flag_code: "NL",
    phone_code: 31,
    region: "Western Europe",
    region_aggregated: "Europe",
    value: "Netherlands",
    label: "Netherlands",
  },
  {
    country_code: "NC",
    flag_code: "NC",
    phone_code: 687,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "New Caledonia",
    label: "New Caledonia",
  },
  {
    country_code: "NZ",
    flag_code: "NZ",
    phone_code: 64,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "New Zealand",
    label: "New Zealand",
  },
  {
    country_code: "NI",
    flag_code: "NI",
    phone_code: 505,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Nicaragua",
    label: "Nicaragua",
  },
  {
    country_code: "NE",
    flag_code: "NE",
    phone_code: 227,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Niger",
    label: "Niger",
  },
  {
    country_code: "NG",
    flag_code: "NG",
    phone_code: 234,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Nigeria",
    label: "Nigeria",
  },
  {
    country_code: "NU",
    flag_code: "NU",
    phone_code: 683,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Niue",
    label: "Niue",
  },
  {
    country_code: "NF",
    flag_code: "NF",
    phone_code: 672,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Norfolk Island",
    label: "Norfolk Island",
  },
  {
    country_code: "KP",
    flag_code: "KP",
    phone_code: 850,
    region: "Japan & Korea",
    region_aggregated: "Japan & Korea",
    value: "North Korea",
    label: "North Korea",
  },
  {
    country_code: "MK",
    flag_code: "MK",
    phone_code: 389,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "North Macedonia",
    label: "North Macedonia",
  },
  {
    country_code: "MP",
    flag_code: "MP",
    phone_code: 1670,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Northern Mariana Islands",
    label: "Northern Mariana Islands",
  },
  {
    country_code: "NO",
    flag_code: "NO",
    phone_code: 47,
    region: "Nordics",
    region_aggregated: "Europe",
    value: "Norway",
    label: "Norway",
  },
  {
    country_code: "OM",
    flag_code: "OM",
    phone_code: 968,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Oman",
    label: "Oman",
  },
  {
    country_code: "PK",
    flag_code: "PK",
    phone_code: 92,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Pakistan",
    label: "Pakistan",
  },
  {
    country_code: "PW",
    flag_code: "PW",
    phone_code: 680,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Palau",
    label: "Palau",
  },
  {
    country_code: "PA",
    flag_code: "PA",
    phone_code: 507,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Panama",
    label: "Panama",
  },
  {
    country_code: "PG",
    flag_code: "PG",
    phone_code: 675,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Papua New Guinea",
    label: "Papua New Guinea",
  },
  {
    country_code: "PY",
    flag_code: "PY",
    phone_code: 595,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Paraguay",
    label: "Paraguay",
  },
  {
    country_code: "PE",
    flag_code: "PE",
    phone_code: 51,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Peru",
    label: "Peru",
  },
  {
    country_code: "PH",
    flag_code: "PH",
    phone_code: 63,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Philippines",
    label: "Philippines",
  },
  {
    country_code: "PN",
    flag_code: "PN",
    phone_code: 64,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Pitcairn",
    label: "Pitcairn",
  },
  {
    country_code: "PL",
    flag_code: "PL",
    phone_code: 48,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Poland",
    label: "Poland",
  },
  {
    country_code: "PT",
    flag_code: "PT",
    phone_code: 351,
    region: "Southern Europe",
    region_aggregated: "Europe",
    value: "Portugal",
    label: "Portugal",
  },
  {
    country_code: "PR",
    flag_code: "PR",
    phone_code: 1,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Puerto Rico",
    label: "Puerto Rico",
  },
  {
    country_code: "QA",
    flag_code: "QA",
    phone_code: 974,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Qatar",
    label: "Qatar",
  },
  {
    country_code: "RO",
    flag_code: "RO",
    phone_code: 40,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Romania",
    label: "Romania",
  },
  {
    country_code: "RU",
    flag_code: "RU",
    phone_code: 7,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Russia",
    label: "Russia",
  },
  {
    country_code: "RW",
    flag_code: "RW",
    phone_code: 250,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Rwanda",
    label: "Rwanda",
  },
  {
    country_code: "RE",
    flag_code: "RE",
    phone_code: 262,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Réunion",
    label: "Réunion",
  },
  {
    country_code: "BL",
    flag_code: "BL",
    phone_code: 590,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Saint Barthélemy",
    label: "Saint Barthélemy",
  },
  {
    country_code: "SH",
    flag_code: "GB",
    phone_code: 290,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Saint Helena",
    label: "Saint Helena",
  },
  {
    country_code: "KN",
    flag_code: "KN",
    phone_code: 1869,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Saint Kitts and Nevis",
    label: "Saint Kitts and Nevis",
  },
  {
    country_code: "LC",
    flag_code: "LC",
    phone_code: 1758,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Saint Lucia",
    label: "Saint Lucia",
  },
  {
    country_code: "MF",
    flag_code: "MF",
    phone_code: 590,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Saint Martin (French part)",
    label: "Saint Martin (French part)",
  },
  {
    country_code: "PM",
    flag_code: "PM",
    phone_code: 508,
    region: "North America",
    region_aggregated: "North America",
    value: "Saint Pierre and Miquelon",
    label: "Saint Pierre and Miquelon",
  },
  {
    country_code: "VC",
    flag_code: "VC",
    phone_code: 1784,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Saint Vincent and the Grenadines",
    label: "Saint Vincent and the Grenadines",
  },
  {
    country_code: "WS",
    flag_code: "WS",
    phone_code: 685,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Samoa",
    label: "Samoa",
  },
  {
    country_code: "SM",
    flag_code: "SM",
    phone_code: 378,
    region: "Southern Europe",
    region_aggregated: "Europe",
    value: "San Marino",
    label: "San Marino",
  },
  {
    country_code: "ST",
    flag_code: "ST",
    phone_code: 239,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Sao Tome & Principe",
    label: "Sao Tome & Principe",
  },
  {
    country_code: "SA",
    flag_code: "SA",
    phone_code: 966,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Saudi Arabia",
    label: "Saudi Arabia",
  },
  {
    country_code: "SN",
    flag_code: "SN",
    phone_code: 221,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Senegal",
    label: "Senegal",
  },
  {
    country_code: "RS",
    flag_code: "RS",
    phone_code: 381,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Serbia",
    label: "Serbia",
  },
  {
    country_code: "SC",
    flag_code: "SC",
    phone_code: 248,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Seychelles",
    label: "Seychelles",
  },
  {
    country_code: "SL",
    flag_code: "SL",
    phone_code: 232,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Sierra Leone",
    label: "Sierra Leone",
  },
  {
    country_code: "SG",
    flag_code: "SG",
    phone_code: 65,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Singapore",
    label: "Singapore",
  },
  {
    country_code: "SX",
    flag_code: "SX",
    phone_code: 1721,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Sint Maarten (Dutch part)",
    label: "Sint Maarten (Dutch part)",
  },
  {
    country_code: "SK",
    flag_code: "SK",
    phone_code: 421,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Slovakia",
    label: "Slovakia",
  },
  {
    country_code: "SI",
    flag_code: "SI",
    phone_code: 386,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Slovenia",
    label: "Slovenia",
  },
  {
    country_code: "SB",
    flag_code: "SB",
    phone_code: 677,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Solomon Islands",
    label: "Solomon Islands",
  },
  {
    country_code: "SO",
    flag_code: "SO",
    phone_code: 252,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Somalia",
    label: "Somalia",
  },
  {
    country_code: "ZA",
    flag_code: "ZA",
    phone_code: 27,
    region: "Africa",
    region_aggregated: "Africa",
    value: "South Africa",
    label: "South Africa",
  },
  {
    country_code: "GS",
    flag_code: "GS",
    phone_code: 500,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "South Georgia and the South Sandwich Islands",
    label: "South Georgia and the South Sandwich Islands",
  },
  {
    country_code: "KR",
    flag_code: "KR",
    phone_code: 82,
    region: "Japan & Korea",
    region_aggregated: "Japan & Korea",
    value: "South Korea",
    label: "South Korea",
  },
  {
    country_code: "SS",
    flag_code: "SS",
    phone_code: 211,
    region: "Africa",
    region_aggregated: "Africa",
    value: "South Sudan",
    label: "South Sudan",
  },
  {
    country_code: "ES",
    flag_code: "ES",
    phone_code: 34,
    region: "Southern Europe",
    region_aggregated: "Europe",
    value: "Spain",
    label: "Spain",
  },
  {
    country_code: "LK",
    flag_code: "LK",
    phone_code: 94,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Sri Lanka",
    label: "Sri Lanka",
  },
  {
    country_code: "PS",
    flag_code: "PS",
    phone_code: 970,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "State of Palestine",
    label: "State of Palestine",
  },
  {
    country_code: "SD",
    flag_code: "SD",
    phone_code: 249,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Sudan",
    label: "Sudan",
  },
  {
    country_code: "SR",
    flag_code: "SR",
    phone_code: 597,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Suriname",
    label: "Suriname",
  },
  {
    country_code: "SJ",
    flag_code: "NO",
    phone_code: 47,
    region: "Nordics",
    region_aggregated: "Europe",
    value: "Svalbard and Jan Mayen",
    label: "Svalbard and Jan Mayen",
  },
  {
    country_code: "SE",
    flag_code: "SE",
    phone_code: 46,
    region: "Nordics",
    region_aggregated: "Europe",
    value: "Sweden",
    label: "Sweden",
  },
  {
    country_code: "CH",
    flag_code: "CH",
    phone_code: 41,
    region: "Western Europe",
    region_aggregated: "Europe",
    value: "Switzerland",
    label: "Switzerland",
  },
  {
    country_code: "SY",
    flag_code: "SY",
    phone_code: 963,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Syria",
    label: "Syria",
  },
  {
    country_code: "TW",
    flag_code: "TW",
    phone_code: 886,
    region: "Japan & Korea",
    region_aggregated: "Japan & Korea",
    value: "Taiwan",
    label: "Taiwan",
  },
  {
    country_code: "TJ",
    flag_code: "TJ",
    phone_code: 992,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Tajikistan",
    label: "Tajikistan",
  },
  {
    country_code: "TZ",
    flag_code: "TZ",
    phone_code: 255,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Tanzania",
    label: "Tanzania",
  },
  {
    country_code: "TH",
    flag_code: "TH",
    phone_code: 66,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Thailand",
    label: "Thailand",
  },
  {
    country_code: "BS",
    flag_code: "BS",
    phone_code: 1242,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "The Bahamas",
    label: "The Bahamas",
  },
  {
    country_code: "TL",
    flag_code: "TL",
    phone_code: 670,
    region: "East Asia & Pacific",
    region_aggregated: "East Asia & Pacific",
    value: "Timor-Leste",
    label: "Timor-Leste",
  },
  {
    country_code: "TG",
    flag_code: "TG",
    phone_code: 228,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Togo",
    label: "Togo",
  },
  {
    country_code: "TK",
    flag_code: "TK",
    phone_code: 690,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Tokelau",
    label: "Tokelau",
  },
  {
    country_code: "TO",
    flag_code: "TO",
    phone_code: 676,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Tonga",
    label: "Tonga",
  },
  {
    country_code: "TT",
    flag_code: "TT",
    phone_code: 1868,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Trinidad and Tobago",
    label: "Trinidad and Tobago",
  },
  {
    country_code: "TN",
    flag_code: "TN",
    phone_code: 216,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Tunisia",
    label: "Tunisia",
  },
  {
    country_code: "TR",
    flag_code: "TR",
    phone_code: 90,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Turkey",
    label: "Turkey",
  },
  {
    country_code: "TM",
    flag_code: "TM",
    phone_code: 993,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Turkmenistan",
    label: "Turkmenistan",
  },
  {
    country_code: "TC",
    flag_code: "TC",
    phone_code: 1649,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Turks and Caicos Islands",
    label: "Turks and Caicos Islands",
  },
  {
    country_code: "TV",
    flag_code: "TV",
    phone_code: 688,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Tuvalu",
    label: "Tuvalu",
  },
  {
    country_code: "UG",
    flag_code: "UG",
    phone_code: 256,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Uganda",
    label: "Uganda",
  },
  {
    country_code: "UA",
    flag_code: "UA",
    phone_code: 380,
    region: "Central & Eastern Europe",
    region_aggregated: "Europe",
    value: "Ukraine",
    label: "Ukraine",
  },
  {
    country_code: "AE",
    flag_code: "AE",
    phone_code: 971,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "United Arab Emirates",
    label: "United Arab Emirates",
  },
  {
    country_code: "UK",
    flag_code: "GB",
    phone_code: 44,
    region: "UK&I",
    region_aggregated: "Europe",
    value: "United Kingdom",
    label: "United Kingdom",
  },
  {
    country_code: "UM",
    flag_code: "US",
    phone_code: 1,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "United States Minor Outlying Islands",
    label: "United States Minor Outlying Islands",
  },
  {
    country_code: "US",
    flag_code: "US",
    phone_code: 1,
    region: "North America",
    region_aggregated: "North America",
    value: "United States of America",
    label: "United States of America",
  },
  {
    country_code: "UY",
    flag_code: "UY",
    phone_code: 598,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Uruguay",
    label: "Uruguay",
  },
  {
    country_code: "UZ",
    flag_code: "UZ",
    phone_code: 998,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Uzbekistan",
    label: "Uzbekistan",
  },
  {
    country_code: "VU",
    flag_code: "VU",
    phone_code: 678,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Vanuatu",
    label: "Vanuatu",
  },
  {
    country_code: "VE",
    flag_code: "VE",
    phone_code: 58,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Venezuela",
    label: "Venezuela",
  },
  {
    country_code: "VN",
    flag_code: "VN",
    phone_code: 84,
    region: "South Asia",
    region_aggregated: "South Asia",
    value: "Vietnam",
    label: "Vietnam",
  },
  {
    country_code: "VG",
    flag_code: "VG",
    phone_code: 1284,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Virgin Islands (British)",
    label: "Virgin Islands (British)",
  },
  {
    country_code: "VI",
    flag_code: "VI",
    phone_code: 1340,
    region: "Spanish LATAM",
    region_aggregated: "Spanish LATAM",
    value: "Virgin Islands (U.S.)",
    label: "Virgin Islands (U.S.)",
  },
  {
    country_code: "WF",
    flag_code: "WF",
    phone_code: 681,
    region: "Oceania",
    region_aggregated: "Oceania",
    value: "Wallis and Futuna",
    label: "Wallis and Futuna",
  },
  {
    country_code: "EH",
    flag_code: "EH",
    phone_code: 212,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Western Sahara",
    label: "Western Sahara",
  },
  {
    country_code: "YE",
    flag_code: "YE",
    phone_code: 967,
    region: "Middle East",
    region_aggregated: "Middle East",
    value: "Yemen",
    label: "Yemen",
  },
  {
    country_code: "ZM",
    flag_code: "ZM",
    phone_code: 260,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Zambia",
    label: "Zambia",
  },
  {
    country_code: "ZW",
    flag_code: "ZW",
    phone_code: 263,
    region: "Africa",
    region_aggregated: "Africa",
    value: "Zimbabwe",
    label: "Zimbabwe",
  },
  {
    country_code: "AX",
    flag_code: "AX",
    phone_code: 358,
    region: "Nordics",
    region_aggregated: "Europe",
    value: "Åland Islands",
    label: "Åland Islands",
  },
] as const satisfies readonly Country[];

/** Options for Payload select / dropdown: value = ISO 3166-1 alpha-2 code, label = country name. Sorted by name. */
export const COUNTRY_SELECT_OPTIONS: { label: string; value: string }[] = [...COUNTRY_DATA]
  .map(c => ({ label: c.label, value: c.country_code }))
  .sort((a, b) => a.label.localeCompare(b.label));

/** Unique aggregated region values for Payload select fields. Sorted alphabetically. */
export const REGION_SELECT_OPTIONS: { label: string; value: string }[] = [
  ...new Set(COUNTRY_DATA.map(c => c.region_aggregated)),
]
  .sort((a, b) => a.localeCompare(b))
  .map(r => ({ label: r, value: r }));

/** Look up the aggregated region for a country code (case-insensitive). */
export function getRegionForCountry(countryCode: string): string | null {
  const upper = countryCode.toUpperCase();
  return COUNTRY_DATA.find(c => c.country_code === upper)?.region_aggregated ?? null;
}

/** Get all country codes belonging to an aggregated region. */
export function getCountryCodesForRegion(region: string): CountryCode[] {
  return COUNTRY_DATA.filter(c => c.region_aggregated === region).map(c => c.country_code);
}

export type CountryCode = (typeof COUNTRY_DATA)[number]["country_code"];
export type CountryName = (typeof COUNTRY_DATA)[number]["value"];

export const EXPECTED_MONTHLY_USAGE_COUNTRIES: CountryName[] = [
  "Antigua and Barbuda",
  "Anguilla",
  "Argentina",
  "Aruba",
  "Barbados",
  "Saint Barthélemy",
  "Bolivia",
  "Bonaire, Sint Eustatius and Saba",
  "The Bahamas",
  "Bouvet Island",
  "Belize",
  "Chile",
  "Colombia",
  "Costa Rica",
  "Cuba",
  "Curaçao",
  "Dominica",
  "Dominican Republic",
  "Ecuador",
  "Falkland Islands (Malvinas)",
  "Grenada",
  "French Guiana",
  "Guadeloupe",
  "South Georgia and the South Sandwich Islands",
  "Guatemala",
  "Guyana",
  "Honduras",
  "Haiti",
  "Jamaica",
  "Saint Kitts and Nevis",
  "Cayman Islands",
  "Saint Lucia",
  "Saint Martin (French part)",
  "Martinique",
  "Montserrat",
  "Mexico",
  "Nicaragua",
  "Panama",
  "Peru",
  "Puerto Rico",
  "Paraguay",
  "Suriname",
  "El Salvador",
  "Sint Maarten (Dutch part)",
  "Turks and Caicos Islands",
  "Trinidad and Tobago",
  "Uruguay",
  "Saint Vincent and the Grenadines",
  "Venezuela",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Azerbaijan",
  "Bangladesh",
  "Bhutan",
  "Indonesia",
  "British Indian Ocean Territory",
  "Cambodia",
  "Kazakhstan",
  "Laos",
  "Sri Lanka",
  "Myanmar",
  "Maldives",
  "Malaysia",
  "Nepal",
  "Philippines",
  "Pakistan",
  "Singapore",
  "Thailand",
  "Vietnam",
  "Brunei",
  "China",
  "Hong Kong",
  "Mongolia",
  "Macao",
  "Timor-Leste",
  "American Samoa",
  "Australia",
  "Cocos (Keeling) Islands",
  "Cook Islands",
  "Christmas Island",
  "Fiji",
  "Micronesia (Federated States of)",
  "Guam",
  "Heard Island and McDonald Islands",
  "Kiribati",
  "Marshall Islands",
  "Northern Mariana Islands",
  "New Caledonia",
  "Norfolk Island",
  "Nauru",
  "Niue",
  "New Zealand",
  "French Polynesia",
  "Papua New Guinea",
  "Pitcairn",
  "Palau",
  "Solomon Islands",
  "Tokelau",
  "Tonga",
  "Tuvalu",
  "United States Minor Outlying Islands",
  "Vanuatu",
  "Wallis and Futuna",
  "Samoa",
  "India",
  "Brazil",
];
